/**
 * useFieldRedesign — is the tech-app redesign (field_redesign_v2) on for the
 * signed-in user? (#821)
 *
 * FAIL-CLOSED POLARITY: every state that isn't a confirmed server "true" —
 * loading, an error, a malformed payload, a 401 — reads as OFF. The field
 * shell gates on this, and techs must always get today's app rather than a
 * half-rendered new one. (Deliberately the opposite of report-input-gate,
 * which fails open — correct for a nudge, wrong for a whole UI.)
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useFieldRedesign(): { enabled: boolean } {
    const { data } = useQuery({
        queryKey: ["field-redesign-flag"],
        queryFn: () => api.get<{ enabled: boolean }>("/api/field/redesign-flag"),
        staleTime: 5 * 60_000,
        retry: 1,
    });
    return { enabled: data?.enabled === true };
}
